import { Paragraph as o } from "./paragraph.js";
export {
  o as Paragraph
};
